
import http from "../../../../../common/services/http";
import { computed, defineComponent, onMounted, ref, watch } from "vue";
import moment from "moment";
import router from "../../router";
import { format } from "date-fns";
import NgongVegBanner from "@/components/NgongVegBanner.vue";

export default defineComponent({
  components: { NgongVegBanner },
  setup(props) {
    const form = ref({});

    const farms = ref([]);
    const farm_id = ref(0);

    const farmName = computed(() => {
      const n = farms.value?.find((f: any) => f.id == farm_id.value);

      return n?.["name"];
    });

    const varieties = ref([]);

    const search = ref("");

    const processing = ref(false);
    const created = ref(false);
    const updated = ref(false);
    const day = ref(0);
    const date = ref(new Date());

    const today = computed(() => new Date());

    const prod = ref(1);

    function wednesday() {
      const date = new Date();
      const last = new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000);

      return date.getDay() < 3
        ? new Date(last.setDate(last.getDate() - (last.getDay() - 1) + 2))
        : new Date(date.setDate(date.getDate() - (date.getDay() - 1) + 2));
    }
    const start = ref(wednesday());
    const end = computed(
      () => new Date(new Date(start.value).getTime() + 6 * 24 * 60 * 60 * 1000)
    );

    const masks = ref({
      input: "YYYY-MM-DD"
    });

    function getDates(s: any) {
      const e = new Date(new Date(s).getTime() + 6 * 24 * 60 * 60 * 1000);

      const dates = [];
      let currentDate = moment(s);
      const eDate = moment(e);
      while (currentDate <= eDate) {
        dates.push(moment(currentDate).format("YYYY-MM-DD"));
        currentDate = moment(currentDate).add(1, "days");
      }

      return dates;
    }

    function fD(d: any, f = "PPPP") {
      return format(d, f);
    }

    function addRep(u: any) {
      u.push({ dnote_no: "", dnote: 0, intake: 0, tpackout: 0 });
    }

    function delRep(u: any, i: any) {
      u.splice(i, 1);
    }

    function addUpValues(arr: any, key: string) {
      arr[key] = arr.multi_intake.reduce(
        (accumulator: number, current: { [x: string]: any }) =>
          accumulator + Number(current[key]),
        0
      );
    }

    function deliveryNoteVariance(expected_volume: any, weight: any) {
      return weight - expected_volume;
    }

    function intakeWeightVariance(d_weight: any, i_weight: any) {
      return d_weight - i_weight;
    }

    function variancePercentage(d_weight: any, i_weight: any) {
      const variance = intakeWeightVariance(d_weight, i_weight);
      return i_weight === 0 ? 0 : Math.round((variance / i_weight) * 100);
    }

    function fetchFarms() {
      processing.value = true;
      http.get(`/api/farms?fetch=all`).then(res => {
        farms.value = res.data;
        processing.value = false;
      });
    }

    async function fetchPicks(f: any) {
      const res = await http.get(
        `/api/picks?farm_id=${f}&start=${fD(
          start.value,
          "yyyy-MM-dd"
        )}&end=${fD(end.value, "yyyy-MM-dd")}`
      );

      return res.data.data;
    }

    function fetchVarieties(id: any) {
      processing.value = true;

      fetchPicks(id).then((ps: any) => {
        http.get(`/api/varieties?fetch=all`).then(res => {
          const a = res.data;
          varieties.value = a;

          const dates = getDates(start.value);

          form.value = dates.reduce((o, d) => {
            const p: any = ps.find((or: any) => or.date == d);

            return {
              ...o,
              [d]: a.reduce(
                (r: any, v: any) => ({
                  ...r,
                  [v.id]: {
                    projected:
                      ((p?.quantities as any)[v.id] as any)?.projected || 0,
                    ammended:
                      ((p?.quantities as any)[v.id] as any)?.ammended || 0,
                    declared:
                      ((p?.quantities as any)[v.id] as any)?.declared || 0,
                    intake: ((p?.quantities as any)[v.id] as any)?.intake || 0,
                    dnote: ((p?.quantities as any)[v.id] as any)?.dnote || 0,
                    fpackout:
                      ((p?.quantities as any)[v.id] as any)?.fpackout || 0,
                    tpackout:
                      ((p?.quantities as any)[v.id] as any)?.tpackout || 0,
                    comment:
                      ((p?.quantities as any)[v.id] as any)?.comment || "",
                    multi_intake: ((p?.quantities as any)[v.id] as any)
                      ?.multi_intake || [
                      {
                        dnote_no:
                          ((p?.quantities as any)[v.id] as any)?.multi_intake
                            ?.dnote_no || "",
                        dnote:
                          ((p?.quantities as any)[v.id] as any)?.multi_intake
                            ?.dnote || 0,
                        intake:
                          ((p?.quantities as any)[v.id] as any)?.multi_intake
                            ?.intake || 0,
                        tpackout:
                          ((p?.quantities as any)[v.id] as any)?.multi_intake
                            ?.tpackout || 0
                      }
                    ]
                  }
                }),
                {}
              )
            };
          }, {});
          processing.value = false;
        });
      });
    }

    function searchVarieties() {
      fetchPicks(farm_id.value).then((ps: any) => {
        http.get(`/api/varieties?s=${search.value}&fetch=all`).then(res => {
          const a = res.data.data;
          varieties.value = a;

          const dates = getDates(start.value);

          form.value = dates.reduce((o, d) => {
            const p: any = ps.find((or: any) => or.date == d);

            return {
              ...o,
              [d]: a.reduce(
                (r: any, v: any) => ({
                  ...r,
                  [v.id]: {
                    projected:
                      ((p?.quantities as any)[v.id] as any)?.projected || 0,
                    ammended:
                      ((p?.quantities as any)[v.id] as any)?.ammended || 0,
                    declared:
                      ((p?.quantities as any)[v.id] as any)?.declared || 0,
                    intake: ((p?.quantities as any)[v.id] as any)?.intake || 0,
                    dnote: ((p?.quantities as any)[v.id] as any)?.dnote || 0,
                    fpackout:
                      ((p?.quantities as any)[v.id] as any)?.fpackout || 0,
                    tpackout:
                      ((p?.quantities as any)[v.id] as any)?.tpackout || 0,
                    comment:
                      ((p?.quantities as any)[v.id] as any)?.comment || ""
                  }
                }),
                {}
              )
            };
          }, {});
        });
      });
    }

    function savePicks() {
      http
        .post("/api/picks", {
          farm_id: farm_id.value,
          picks: form.value,
          start: start.value,
          end: end.value
        })
        .then(res => {
          if (res.data.success) {
            created.value = true;
          }
        })
        .finally(() => {
          fetchVarieties(farm_id.value);
        });
    }

    function setDay(i = 0, d: any) {
      day.value = i;
      date.value = d;
    }

    function setProd(n: 0) {
      prod.value = n;
    }

    function getPercentage(a: any, b: any) {
      return b === 0 ? 0 : Math.round((a / b) * 100);
    }

    onMounted(() => {
      fetchFarms();

      if (router.currentRoute.value.query?.farm_id) {
        const f = router.currentRoute.value.query?.farm_id;

        farm_id.value = Number(f);
        fetchVarieties(f);
      } else {
        farm_id.value = 1;
        fetchVarieties(1);
      }
    });

    watch(
      () => end.value,
      (v: any) => {
        fetchVarieties(farm_id.value);
      }
    );

    return {
      fetchVarieties,
      processing,
      search,
      searchVarieties,
      varieties,
      savePicks,
      created,
      updated,
      fD,
      today,
      start,
      end,
      masks,
      getDates,
      setDay,
      day,
      date,
      form,
      farms,
      farmName,
      farm_id,
      prod,
      setProd,
      getPercentage,
      addRep,
      delRep,
      addUpValues,
      deliveryNoteVariance,
      intakeWeightVariance
    };
  }
});
